import { postWithJson, get } from 'library/utils/serviceUtil'; // 导入封装好的axios

// 获取待办列表 数据
export const queryPeddingList = params => postWithJson('/applyNew/list.json', params); 
// 获取所有流程类型
export const queryApplyTypeList = params => get('/application/ApplyType.json', params); 
// 获取tab页数据
export const getNum = params => postWithJson('/application/processNum.json', params); // 获取总数
// 获取我发起的列表 数据
export const queryMyStartList = params => postWithJson('/application/myStartList.json', params); 
// 获取预算单位 预算大类 预算类型 年度
export const getOriTree = params => postWithJson('/budgetDetailTemp/dic/treeList.json', params);
// 查询流程状态
export const queryApplyStatusList = params => get('/application/ApplyStatus.json', params);
